import Vue from 'vue'

const sha1 = require('js-sha1')
const moment = require('moment')

const MWM_USERS_DEV_AUTHORIZATION_ROOT = 'https://dev-dot-authorization-dot-mwm-users.appspot.com'
const MWM_USERS_AUTHORIZATION_ROOT = 'https://authorization-dot-mwm-users.appspot.com'

export default {

  registerAccount (payload) {
    let root = MWM_USERS_AUTHORIZATION_ROOT
    if (payload.env === 'dev') { root = MWM_USERS_DEV_AUTHORIZATION_ROOT }
    return Vue.http.post(root + '/user/mail/register', payload.body, { headers: {} })
      .then((response) => Promise.resolve(response.body))
      .catch((error) => Promise.reject(error))
  },

  requestResetPassword (payload) {
    let root = MWM_USERS_AUTHORIZATION_ROOT
    if (payload.env === 'dev') { root = MWM_USERS_DEV_AUTHORIZATION_ROOT }
    return Vue.http.post(root + '/user/mail/reset-password/request', payload.body, { headers: {} })
      .then((response) => Promise.resolve(response.body))
      .catch((error) => Promise.reject(error))
  },

  verifyMail (payload) {
    let root = MWM_USERS_AUTHORIZATION_ROOT
    if (payload.env === 'dev') { root = MWM_USERS_DEV_AUTHORIZATION_ROOT }
    return Vue.http.post(root + '/user/mail/verify', payload.body, { headers: {} })
      .then((response) => Promise.resolve(response.body))
      .catch((error) => Promise.reject(error))
  },

  finalizeAccount (payload) {
    let root = MWM_USERS_AUTHORIZATION_ROOT
    if (payload.env === 'dev') { root = MWM_USERS_DEV_AUTHORIZATION_ROOT }
    return Vue.http.post(root + '/user/mail/register/finalize', payload.body, { headers: {} })
      .then((response) => Promise.resolve(response.body))
      .catch((error) => Promise.reject(error))
  },

  resetPassword (payload) {
    let root = MWM_USERS_AUTHORIZATION_ROOT
    if (payload.env === 'dev') { root = MWM_USERS_DEV_AUTHORIZATION_ROOT }
    return Vue.http.post(root + '/user/mail/reset-password', payload.body, { headers: {} })
      .then((response) => Promise.resolve(response.body))
      .catch((error) => Promise.reject(error))
  }

}
